import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import type { CultureMapItemModel } from '../../entities/culture-map-item.model';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { CultureMapOfferingItemModel } from '../../entities/culture-map-offering-item.model';
import { CultureMapFacilityItemModel } from '../../entities/culture-map-facility-item.model';

@Component({
    selector: 'ui-culture-map-item-popup-content',
    imports: [DetailViewModule],
    templateUrl: './culture-map-item-popup-content.component.html',
    styleUrl: './culture-map-item-popup-content.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CultureMapItemPopupContentComponent implements MapItemComponent<CultureMapItemModel> {
    public mapItem = input<CultureMapItemModel | undefined>();

    public get offering(): CultureMapOfferingItemModel | undefined {
        const mapItem = this.mapItem();

        return mapItem instanceof CultureMapOfferingItemModel ? mapItem : undefined;
    }

    public get facility(): CultureMapFacilityItemModel | undefined {
        const mapItem = this.mapItem();

        return mapItem instanceof CultureMapFacilityItemModel ? mapItem : undefined;
    }
}
